import React from 'react';
import { formatZeitpunkt, type TeilnahmeErgebnis } from './einweisungTeilnahmeLogic';
import { HINWEISKASTEN, KNOPF_SEKUNDAER } from '../../sifa/public/teilnahmeSeiteStil';

/**
 * Letzte Karte: Haken, Dank mit Name und Zeitpunkt. Bei `bereits` (dieselbe
 * Person hat den QR ein zweites Mal gescannt) sagt die Seite das — die RPC
 * legt kein Doppel an, der erste Eintrag bleibt. „Nächste Person" setzt das
 * Formular zurueck (Firma und Funktion bleiben) und beginnt beim Inhalt, damit
 * ein Handy weitergereicht werden kann.
 */
export const EinweisungErgebnis: React.FC<{
  ergebnis: TeilnahmeErgebnis;
  onNaechstePerson: () => void;
}> = ({ ergebnis, onNaechstePerson }) => {
  const zeitpunkt = formatZeitpunkt(ergebnis.unterschriebenAm);

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <span
          aria-hidden="true"
          className="flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 text-emerald-700 shrink-0"
        >
          <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 13l4 4L19 7" />
          </svg>
        </span>
        <h2 className="text-2xl font-bold text-emerald-700">{ergebnis.bereits ? 'Bereits eingetragen' : 'Eingetragen'}</h2>
      </div>

      <p className="text-slate-700" aria-live="polite">
        {ergebnis.bereits ? (
          <>
            Du warst bereits eingetragen, <strong>{ergebnis.name}</strong>
            {zeitpunkt ? ` (${zeitpunkt})` : ''}. Ein zweiter Eintrag ist nicht nötig.
          </>
        ) : (
          <>
            Danke, <strong>{ergebnis.name}</strong> — du bist eingetragen{zeitpunkt ? ` (${zeitpunkt})` : ''}.
          </>
        )}
      </p>

      <div className={HINWEISKASTEN}>
        Die Einweisung ist damit für dich dokumentiert. Du kannst dieses Fenster jetzt schließen — oder das Gerät an die
        nächste Person weitergeben.
      </div>

      <button type="button" onClick={onNaechstePerson} className={KNOPF_SEKUNDAER}>
        Nächste Person
      </button>
    </div>
  );
};
